<template>
  <v-app class="app" :style="{ backgroundColor: theme.backgroundColor }">
    <v-main class="main">
      <v-app-bar
        dense
        app
        color="primary"
        :dark="!theme.dark"
        class="d-flex justify-center"
        style="text-align:center;"
      >
        {{ title }}
      </v-app-bar>
      <Introduction v-if="currentNode === null" @continue="onIntroDone" />
      <Battery
        v-else
        @capture="onCaptureLabel"
        @question="onAnswerQuestion"
        @skip="onSkipQuestion"
      />
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import Battery from './components/Battery.vue';
import Introduction from './components/Introduction.vue';
import vuetify from './plugins/vuetify';

export default {
  name: 'App',
  components: {
    Battery,
    Introduction,
  },
  computed: {
    ...mapState(['currentNode', 'nodes', 'theme', 'title']),
  },
  created() {
    this.$store.dispatch('loadQualifier');
  },
  data: () => ({
    //
  }),
  methods: {
    onIntroDone() {
      this.$store.dispatch('selectFirstNode');
    },
    onCaptureLabel(info) {
      this.$store.dispatch('processLabel', info);
    },
    onAnswerQuestion(info) {
      this.$store.dispatch('submitResponse', info);
    },
    onSkipQuestion() {
      this.$store.dispatch('skipNode');
    },
  },
  watch: {
    theme(val) {
      document.body.style.backgroundColor = val.backgroundColor;
      if (val.dark) {
        vuetify.framework.theme.themes.dark.primary = val.primaryColor;
        vuetify.framework.theme.themes.dark.secondary = val.secondaryColor;
        vuetify.framework.theme.themes.dark.accent = val.accentColor;
        vuetify.framework.theme.themes.dark.error = val.errorColor;
        vuetify.framework.theme.themes.dark.info = val.infoColor;
        vuetify.framework.theme.themes.dark.success = val.successColor;
        vuetify.framework.theme.themes.dark.warning = val.warningColor;
      } else {
        vuetify.framework.theme.themes.light.primary = val.primaryColor;
        vuetify.framework.theme.themes.light.secondary = val.secondaryColor;
        vuetify.framework.theme.themes.light.accent = val.accentColor;
        vuetify.framework.theme.themes.light.error = val.errorColor;
        vuetify.framework.theme.themes.light.info = val.infoColor;
        vuetify.framework.theme.themes.light.success = val.successColor;
        vuetify.framework.theme.themes.light.warning = val.warningColor;
      }
    },
  },
};
</script>

<style lang="scss">
html {
  box-sizing: border-box;
  width: 100vw;
  height: -webkit-fill-available;
  margin: 0px;
  padding: 0px;
}

body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
  margin: 0px;
  padding: 0px;
}

.app {
  align-self: center;
  width: 100vw;
  max-width: 768px;
  min-height: 100%;

  .v-application--wrap {
    min-height: -webkit-fill-available;
  }

  .main {
    width: 100%;
  }
}
</style>
